<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.partner") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
			<div class="col-lg-3">

                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
			</div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash text-white"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.company_name')"
          v-model="md.CompanyName"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.tel')"
          v-model="md.Tel"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input :label="$t('wms.email')" v-model="md.Email"> </base-input>

        <base-input :label="$t('wms.address')" v-model="md.Address">
        </base-input>

        <base-input :label="$t('wms.taxid')" v-model="md.TaxID"> </base-input>

        <base-input :label="$t('wms.contact_name')" v-model="md.ContactName">
        </base-input>

        <base-input :label="$t('wms.contact_tel')" v-model="md.ContactTel">
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import error from "./error";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsPartner/getData",
    }),
    tableData: function () {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    },
    tableColumns: function () {
      // ชื่อบริษัท 50% ของตาราง ที่เหลือ ชื่อผู้ติดต่อ + เบอร์โทรผู้ติดต่อ
      return [
        {
          prop: "CompanyName",
          label: this.$t("wms.company_name"),
          // el-table แบ่งความกว้างตามสัดส่วน minWidth: 420 = ผลรวมคอลัมน์อื่น
          // (ผู้ติดต่อ 120 + เบอร์ 100 + เมนู 200) → ชื่อบริษัท ≈ 50% ของตาราง
          minWidth: 420,
          sortable: true,
        },
        {
          prop: "ContactName",
          label: this.$t("wms.contact_name"),
          minWidth: 120,
          sortable: true,
        },
        {
          prop: "ContactTel",
          label: this.$t("wms.contact_tel"),
          minWidth: 100,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      md: {
        ID: 0,
        CompanyName: "",
        Tel: "",
        Email: "",
        Address: "",
        TaxID: "",
        ContactName: "",
        ContactTel: "",
      },
    };
  },
  mounted() {
    this.listData();
  },
  methods: {
    ...mapActions({
      createData: "WmsPartner/createData",
      updateData: "WmsPartner/updateData",
      deleteData: "WmsPartner/deleteData",
      listData: "WmsPartner/listData",
    }),
    handleCreate() {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.CompanyName = "";
      this.md.Tel = "";
      this.md.Email = "";
      this.md.Address = "";
      this.md.TaxID = "";
      this.md.ContactName = "";
      this.md.ContactTel = "";
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.ID = row.ID;
      this.md.CompanyName = row.CompanyName;
      this.md.Tel = row.Tel;
      this.md.Email = row.Email;
      this.md.Address = row.Address;
      this.md.TaxID = row.TaxID;
      this.md.ContactName = row.ContactName;
      this.md.ContactTel = row.ContactTel;
    },
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData({
          companyName: this.md.CompanyName,
          tel: this.md.Tel,
          email: this.md.Email,
          address: this.md.Address,
          taxId: this.md.TaxID,
          contactName: this.md.ContactName,
          contactTel: this.md.ContactTel,
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update

        this.updateData({
          id: this.md.ID,
          payload : {companyName: this.md.CompanyName,
          tel: this.md.Tel,
          email: this.md.Email,
          address: this.md.Address,
          taxId: this.md.TaxID,
          contactName: this.md.ContactName,
          contactTel: this.md.ContactTel
		  }
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.CompanyName,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData(row.ID)
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
